import { toMoneyInput } from "@/lib/money";
import type { OptionType } from "@/types/common/load-options-types";
import type { Product } from "@/types/products/api-types/product-types";

export function getProductFormValues(product?: Product) {
  return {
    category: product
      ? ({
          value: product.category_id,
          label: product.category_name,
        } as OptionType | null)
      : (null as OptionType | null),
    name: product?.name ?? "",
    brand: product
      ? ({
          value: product.brand_id,
          label: product.brand_name,
        } as OptionType | null)
      : (null as OptionType | null),
    size_value: product?.size_value ?? "",
    size_unit: product?.size_unit ?? "",
    cost_price: (product ? toMoneyInput(product.cost_price) : "") as string | number,
    retail_price: (product ? toMoneyInput(product.retail_price) : "") as string | number,
  };
}
